<template>
  <order-list :is-order-status="60"></order-list>
</template>

<script>
import OrderList from './components/OrderList'
export default {
  name: 'RefundFinished',
  components: {
    OrderList
  }
}
</script>
